import * as React from "react";
import { Scoreboards } from "../../../../constants";
import { eBranches } from "sb-resp-lib";
import * as i from "../../../../contracts";

export class ServingIndicator extends React.PureComponent<{ onServe: string, event: i.Event}, {}>{
    render() {
        let onServeTeamClass = this.props.event.score.additionalScores.onServe === this.props.onServe ? "rj-ev-list__indicator--serving" : "";

        return (
            Scoreboards[eBranches[this.props.event.sportId]]
                ? <span className={`${onServeTeamClass} rj-ev-list__indicator`} data-uat="span-ev-list-indicator"></span>
                : ""
        )
    }
}